import { render, staticRenderFns } from "./MinuteOurSelectoForTasks.vue?vue&type=template&id=739fb289&"
import script from "./MinuteOurSelectoForTasks.vue?vue&type=script&lang=js&"
export * from "./MinuteOurSelectoForTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports